import type { HotStreakState, HotStreakPrivateState } from '@flip7/shared';
import { HS_DOUBLE_DOWN_TIMER_MS, HS_MASCOTS } from '@flip7/shared';
import { useCountdown } from './useCountdown';
import { useHotStreakTips } from '../../hooks/useHotStreakTips';
import { Tooltip } from './Tooltip';

interface Props {
  state: HotStreakState;
  playerId: string | null;
  privateState: HotStreakPrivateState | null;
  onDoubleDown: (betIndex: number) => void;
}

export function HotStreakDoubleDown({ state, playerId, privateState, onDoubleDown }: Props) {
  const player = state.players.find((p) => p.id === playerId);
  const hasChosen = player?.doubledBetIndex !== null;
  const timeLeft = useCountdown(state.draftTimerStartedAt, HS_DOUBLE_DOWN_TIMER_MS);
  const tips = useHotStreakTips();

  const bets = privateState?.bets ?? player?.bets ?? [];

  return (
    <div className="hs-double-down">
      <h2>Double Down!</h2>
      <p className="hs-subtitle">
        Race 3 twist: Pick one bet to pay DOUBLE (gains AND losses!)
      </p>
      <div className="hs-timer">{Math.ceil(timeLeft / 1000)}s</div>

      {hasChosen ? (
        <div className="hs-waiting">
          <p>Waiting for other players...</p>
        </div>
      ) : (
        <div className="hs-double-options">
          {bets.map((bet, i) => {
            const mascotInfo = bet.ticket.mascot ? HS_MASCOTS[bet.ticket.mascot] : null;
            return (
              <button
                key={i}
                className="hs-double-option"
                onClick={() => onDoubleDown(i)}
              >
                <div className="hs-double-label">
                  {mascotInfo?.name ?? bet.ticket.question ?? 'Bet'}
                </div>
                <div className="hs-double-side">{bet.side}</div>
                <div className="hs-double-badge">TAP TO DOUBLE</div>
              </button>
            );
          })}
        </div>
      )}

      {!hasChosen && tips.shouldShow('double-intro') && (
        <Tooltip
          icon="✖2"
          message="Pick one of your bets to DOUBLE! The payout is doubled — but so are any losses. Choose wisely!"
          onDismiss={() => tips.dismiss('double-intro')}
        />
      )}
    </div>
  );
}
